'use client';
import { useRouter, useSearchParams } from 'next/navigation';
import { trackStatistic } from '@/lib/utils/statisticTracker';

export const useSidebarFilter = () => {
  const router = useRouter();
  const searchParams = useSearchParams();

  const isChecked = (groupType: string, optionId: string): boolean =>
    searchParams.get(groupType)?.split(',').includes(String(optionId)) || false;

  const handleCheckboxChange = (
    groupType: string,
    optionId: string,
    checked: boolean
  ) => {
    const current = searchParams.get(groupType)?.split(',').filter(Boolean) || [];
    let next = [...current];

    if (groupType === 'workTypes' || groupType === 'dayAgo') {
      next = [];
    }

    if (checked) {
      trackStatistic('sidebar_filter');
      if (next.includes(String(optionId))) {
        next = next.filter((id) => id !== String(optionId));
      } else {
        next = [...next, String(optionId)];
      }
    } else {
      next = next.filter((id) => id !== String(optionId));
    }

    const params = new URLSearchParams(searchParams.toString());
    if (next.length > 0) {
      params.set(groupType, next.join(','));
    } else {
      params.delete(groupType);
    }
    params.delete('page');
    router.push(`/job/list?${params.toString()}`, { scroll: false });
  };

  return { searchParams, router, isChecked, handleCheckboxChange };
};
